import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="页面不存在 - 53吃瓜"
        description="您访问的页面不存在，返回53吃瓜网首页继续浏览娱乐八卦爆料。"
      />
      <Navbar />
      <main className="pt-20 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <h1 className="font-heading font-black text-8xl md:text-9xl text-primary-200 select-none mb-4">
            404
          </h1>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            页面走丢了
          </h2>
          <p className="text-foreground-500 text-base mb-8">
            这个瓜可能已经被吃掉了，去看看别的吧
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-medium hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}